(function ($) {
    "use strict";

    const KEYS = Object.freeze({
        "mode": 'validation-mode',
        "type": 'validation-type',
        "errormessage": 'validation-errormessage',
        "title": 'validation-title',
        "message": 'validation-message',
        "passwordLink": 'validation-password-link'
    });

    function getInputFields(form) {
        return jQuery(form).find(':input').filter(function () {
            return ($(this).data(KEYS.mode) !== undefined);
        });
    }

    const MODES = Object.freeze({
        "optional": 'optional',
        "required": 'required',
        "validated": 'validated',
        "none": 'none'
    });

    function cleanValidationMode(rawValidationMode) {
        let scrubbed;
        if (rawValidationMode === true) {
            scrubbed = MODES.required;
        }
        else if (rawValidationMode === false) {
            scrubbed = MODES.optional;
        }
        else if (rawValidationMode === MODES.required || rawValidationMode === MODES.optional || rawValidationMode === MODES.validated) {
            scrubbed = rawValidationMode;
        }
        else {
            scrubbed = MODES.none;
        }
        return scrubbed;
    }

    function hasValidationData(fieldSelector) {
        let hasValidation = false;

        if (!FBUtilities.IsStringEmptyOrWhitespace(fieldSelector)) {
            const validationMode = $(fieldSelector).data(KEYS.mode);
            if (validationMode === MODES.required || validationMode === MODES.optional || validationMode === MODES.validated) {
                hasValidation = true;
            }
        }
        return hasValidation;
    }

    const TYPES = Object.freeze({
        "URL_LABEL": "url_label",
        "LOGONNAME": "logonname",
        "HOSTNAME": "hostname",
        "PASSWORD": "password",
        "PASSWORD_LOOSE": "password_loose",
        "EMAIL": "email",
        "EMAIL_COLLECTION": "email_collection",
        "TEL": "tel",
        "PHONE": "phone",
        "FAX": "fax",
        "DATE": "date",
        "DATE_ISO8601": "date_iso8601",
        "DATEINPUT": "date_input",
        "TIME": "time",
        "TIME12H": "time12h",
        "TIMEAMPM": "timeAmPm",
        "TIMEINPUT": "time_input",
        "PERCENT": "percent",
        "PLAINTEXT": "plaintext",
        "PLAINTEXT_NOHTML": "plaintextnohtml",
        "TEXT": "text",
        "TEXT_20": "text_20",
        "TEXT_30": "text_30",
        "TEXT_50": "text_50",
        "TEXT_100": "text_100",
        "TEXT_200": "text_200",
        "TEXT_240": "text_240",
        "TEXT_2048": "text_2048",
        "HTMLID": "htmlid",
        "PATHNAME": "pathname",
        "FILENAME": "filename",
        "SIMPLETEXT": "simpletext",
        "TEXTAREA": "textarea",
        "TEXTAREA_500": "textarea_500",
        "TEXTAREA_200": "textarea_200",
        "TEXT_NO_SPACE": "text_no_space",
        "WEBSITE": "website",
        "WEBSITE_OR_ANCHOR": "website_or_anchor",
        "URLPATH": "urlpath",
        "CANONICALPATH": "canonicalpath",
        "SHORTPATH": "shortpath",
        "MONEY": "money",
        "INTEGER": "integer",
        "BOOLEAN": "boolean",
        "SELECT": "select",
        "RADIO": "radio",
        "POSTALZIP": "postalzip",
        "ZIPCODE": "zipcode",
        "LINKTESTER": "cmslink"
    });

    const REGEXS = Object.freeze({
        "ADDRESS_ANCHOR": /^\#[\S]+$/,
        "ADDRESS_LOCAL": /^(?:\/[a-zA-Z0-9\-\.\_\~\:\?\[\]\@\!\$\&\'\(\)\*\+\,\;\=#]+)+[\/]?$/,
        "ADDRESS_ROOT": /^\/$/,
        "ADDRESS_WEB": /^(?:https?:)?\/\/[a-zA-Z0-9\/\-\.\_\~\:\/\?\[\]\@\!\$\&\'\(\)\*\+\,\;\=#%]+$/,
        "ANY": /.*/,
        "BOOLEAN": /^(((T|t)rue)|((F|f)alse))$/,
        "CANONICALPATH": /^[a-zA-Z0-9]{1,1}[\-a-zA-Z0-9_\/]{1,254}[a-zA-Z0-9]{1,1}$/,
        "DATE_ISO": /(\d{4})-(\d{2})-(\d{2})/,
        "DATE_US": /^(0?[0-9]|1[0-2])\D(0?[0-9]|1[0-9]|2[0-9]|3[0-1])\D(\d{4})$/,
        "DATE_US_PADDED": /(\d{2})[-/](\d{2})[-/](\d{4})/,
        "EMAIL_DOMAIN": /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,62}[a-zA-Z0-9])?\.)*[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,62}[a-zA-Z0-9])?$/,
        "EMAIL_USER": /^[a-zA-Z0-9\Q!#$%&'*+\-\/=?\^_`{\|}~.\E]+$/,
        "FILENAME": /^[a-zA-Z0-9_\-\.]+$/,
        "HOSTNAME": /^[a-zA-Z0-9]+(?:[\-\.][a-zA-Z0-9]+)*$/,
        "HTMLID": /^[a-z]{1}[a-z0-9\-_]{0,199}$/,
        "HTML_TAG": /<\/?[a-zA-Z].*>/,
        "INTEGER": /^\d+$/,
        "LINK_ANCHOR": /^\#[a-z]{1}[a-z0-9\-_]{0,199}$/,
        "LINK_HOSTNAME": /^[a-zA-Z0-9\/\-\.\_\~\:\/\?\[\]\@\!\$\&\'\(\)\*\+\,\;\=%]+$/,
        "LINK_LOCAL": /^(?:\/[a-zA-Z0-9\-\.\_\~\:\?\[\]\@\!\$\&\'\(\)\*\+\,\;\=]+)+[\/]?$/,
        "LINK_MAILTO": /^mailto:[\S]{1,200}$/,
        "LINK_TEL": /^tel:[\S]{1,25}$/,
        "LOGONNAME": /^.{3,}$/,
        "MONEY": /^\d+([\.]\d\d)?$/,
        "PASSWORD": /^[a-zA-Z0-9\~\!\@\#\$\%\^\&\*\_\-\+\=\`\|\\\(\)\{\}\[\]\:\,\"\'<\>\,\.\?\/]{4,50}$/,
        "PASSWORD_LOOSE": /^.+$/,
        "PATHNAME": /^[a-zA-Z0-9_\-]+$/,
        "PERCENTAGE": /^([0-99]{1,2}|100)$/,
        "SHORTPATH": /^[\-a-zA-Z0-9_\.]{1,256}$/,
        "SIMPLETEXT": /^[\w\/\.\,\-\s]+$/,
        "SOMETHING": /^.+$/,
        "TELEPHONE_FULL": /^([\+]?[\d]{1,3}[\-\.\ ])?([\(]?[\d]{3}[\)]?[\-\.\ ])?\d{3}[\-\.\ ]?\d{4}.*$/,
        "TELEPHONE_US": /^1?[\-\ ]?\(?\d{3}\)?[\-\ ]?\d{3}[\-\ ]?\d{4}.*$/,
        "TEXTAREA": /^[\s\S]+$/m,
        "TEXTAREA_200": /^[\s\S]{1,200}$/m,
        "TEXTAREA_500": /^[\s\S]{1,500}$/m,
        "TEXT_NOSPACE": /^[\w]+$/,
        "TEXT_UNLIMITED": /^.+$/,
        "TIME_12H_MERIDIAN": /^(0?[1-9]|1[0-2]):[0-5][0-9]\s([AaPp][Mm])$/,
        "TIME_12H_NOMERIDIAN": /^(1[0-2]|[1-9]):[0-5][0-9]$/,
        "TIME_24H": /^([0-2][0-9]):([0-5][0-9])$/,
        "URLLABEL": /^[a-z0-9\-_]+$/,
        "URLPATH": /^[\-a-zA-Z0-9_\/\.\?=]{1,256}$/,
        "ZIPCODE_CA": /^[a-zA-Z]\d[a-zA-Z]\ ?\d[a-zA-Z]\d$/,
        "ZIPCODE_US": /^\d{5}([\-][\d]{4})?$/
    });

    /// <summary>
    /// Base class for various expression testing objects.
    /// </summary>
    class ExpressionSet {

        expression;
        validationErrorMessage;
        expectedLength;

        constructor() {
            this.expression = {
                "test": function () {
                    return false;
                }
            };
            this.validationErrorMessage = null;
            this.expectedLength = null;
        }

        /// <summary>
        /// Determines if a meaningful value was provided.  A value is meaningful
        /// if a) it is defined, b) it is not null, c) it is not the empty string.
        /// </summary>
        /// <param name="value">The value to check.</param>
        /// <returns>true if a valid is set, otherwise false.</returns>
        isValue(value) {
            return (value !== undefined && value !== null && value !== '');
        }
    }

    /// <summary>
    /// Tester class for passing anything and everything.
    /// </summary>
    class AlwaysPassTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'This should always work.';
            this.expression = {
                "test": function() {
                    return true;
                }
            };
        }
    }

    /// <summary>
    /// Tester for 'cmslink' validation types
    ///   ATTRIBUTES:
    ///     data-cmslink-local - allow local links, default: true.
    ///     data-cmslink-absolute - allow absolute links, default: true.
    ///     data-cmslink-anchor - allow anchor links, default: true.
    ///     data-cmslink-mailto - allow mailto links, default: false.
    ///     data-cmslink-tel - allow tel links, default: false.
    /// </summary>
    class FBLinkTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a link';
            this.expression = {
                "test": function (aValue, aField) {
                    // Anchor hash only.

                    const allowAnchor = FBUtilities.GetBoolOrNull(aField.data('cmslink-anchor')) ?? true;
                    if (allowAnchor && REGEXS.LINK_ANCHOR.test(aValue)) {
                        return true;
                    }

                    // Local only paths.

                    const allowLocalPath = FBUtilities.GetBoolOrNull(aField.data('cmslink-local')) ?? true;
                    if (allowLocalPath) {
                        const index = aValue.indexOf('#');
                        const path = index === -1 ? aValue : aValue.substring(0, index);
                        const hash = index === -1 ? '' : aValue.substring(index);
                        if ((path === '/' || REGEXS.LINK_LOCAL.test(path)) && (hash === '' || REGEXS.LINK_ANCHOR.test(hash))) {
                            return true;
                        }
                    }

                    // Mail links.

                    const allowMailto = FBUtilities.GetBoolOrNull(aField.data('cmslink-mailto')) ?? false;
                    if (allowMailto && REGEXS.LINK_MAILTO.test(aValue)) {
                        return true;
                    }

                    // Phone links.

                    const allowTel = FBUtilities.GetBoolOrNull(aField.data('cmslink-tel')) ?? false;
                    if (allowTel && REGEXS.LINK_TEL.test(aValue)) {
                        return true;
                    }

                    // Absolute web paths.

                    const allowAbsolutePath = FBUtilities.GetBoolOrNull(aField.data('cmslink-absolute')) ?? true;
                    if (allowAbsolutePath && URL.canParse(aValue)) {
                        const url = new URL(aValue);

                        if (url.protocol === 'https:'
                            && REGEXS.LINK_HOSTNAME.test(url.hostname)
                            && url.port === ''
                            && url.username === ''
                            && url.password === ''
                            && (url.hash === '' || REGEXS.ADDRESS_ANCHOR.test(url.hash))
                        ) {
                            return true;
                        }
                    }

                    return false;
                }
            }
        }
    }

    /// <summary>
    /// Tester class that fails everything and anything.
    /// </summary>
    class NeverPassTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'This never works.';
            this.expression = {
                "test": function () {
                    return false;
                }
            };
        }
    }

    /// <summary>
    /// Class for testing passwords.
    /// </summary>
    class PasswordTester extends ExpressionSet {
        
        constructor() {
            super();
            this.validationErrorMessage = 'A password must have between 4 to 50 characters and may be a number, an upper case letter, and a lower case letter, or a symbol. Both fields must match.';
            const self = this;
            this.expression = {
                "test": function (aValue) {
                    return self.isValue(aValue) && REGEXS.PASSWORD.test(aValue);
                }
            };
        }
    }

    /// <summary>
    /// Class for testing passwords with relaxed character restrictions.
    /// </summary>
    class PasswordTesterLoose extends ExpressionSet {
        
        constructor() {
            super();
            const self = this;
            this.validationErrorMessage = 'Please enter the same password into both the password and confirmation fields.';
            this.expression = {
                "test": function (aValue) {
                    return self.isValue(aValue) && REGEXS.PASSWORD_LOOSE.test(aValue);
                }
            };
        }
    }

    /// <summary>
    /// Class for checking a collection of emails.
    /// </summary>
    class EmailCollectionTester extends ExpressionSet {
        emailTester;
        constructor() {
            super();
            const self = this;

            this.emailTester = new EmailTester();
            this.validationErrorMessage = 'Enter one or more valid email addresses here. Separate each individual email with a comma, semi-colon, or a newline.';
            this.expression = {
                "test": (aValue) => self._test(aValue)
            };
        }

        _test(aValue)
        {
            const self = this;
            if (!self.isValue(aValue))
            {
                return false;
            }

            // Normalize LF, CR, and semi-colon separators to commas.
            const cleanValue = aValue
                .replace(/\n\r/g, ",")
                .replace(/\r/g, ",")
                .replace(/\n/g, ",")
                .replace(/;/g, ",");

            // Split normalized clean value by comma.
            const addresses = cleanValue.split(",");
            // must have at least one possible email address.
            if (addresses.length === 0)
            {
                return false;
            }

            // check all possible email addresses.
            for (let i = 0; i < addresses.length; i += 1)
            {
                // ignore whitespace.
                const address = addresses[i].trim();
                // however there still should be something to test.
                if (FBUtilities.IsStringEmptyOrWhitespace(address) || !self.emailTester.expression.test(address))
                {                    
                    return false;
                }
            }
            return true;
        }
    }

    /// <summary>
    /// Class for validating the format of an absolute or relative web address.
    /// </summary>
    class WebAddressTester extends ExpressionSet {

        constructor() {
            super();
            const self = this;
            this.validationErrorMessage = 'Enter a web address.';
            this.expression = {
                "test": function(aValue) {
                    return self.isValue(aValue) && (
                        REGEXS.ADDRESS_WEB.test(aValue)
                        || REGEXS.ADDRESS_ROOT.test(aValue)
                        || REGEXS.ADDRESS_LOCAL.test(aValue)
                    );
                }
            }
        }
    }

    /// <summary>
    /// Class for validating the format of an absolute or relative web address.
    /// </summary>
    class WebAddressOrAnchorTester extends ExpressionSet {

        constructor() {
            super();
            const self = this;
            this.validationErrorMessage = 'Enter a web address or anchor link';
            this.expression = {
                "test": function (aValue) {
                    return self.isValue(aValue) && (
                        REGEXS.ADDRESS_WEB.test(aValue)
                        || REGEXS.ADDRESS_ROOT.test(aValue)
                        || REGEXS.ADDRESS_LOCAL.test(aValue)
                        || REGEXS.LINK_ANCHOR.test(aValue)
                    );
                }
            }
        }
    }

    /// <summary>
    /// Class for validating an url path. (/one/two/three/).
    /// </summary>
    class UrlPathTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter an url path segment. The path may contain lowercase and/or uppercase letters. Query parameters are allowed.';
            this.expression = REGEXS.URLPATH;
        }
    }

    /// <summary>
    /// Class for validating an seo url path. (one/two-too-three).
    /// </summary>
    class CanonicalPathTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a permalink path segment. The path may contain letters, digits, and dashes. Example: informative-and-exciting-story';
            this.expression = REGEXS.CANONICALPATH;
        }
    }

    /// <summary>
    /// Class for validating a single folder name seqment within an url.
    /// </summary>
    class UrlLabelTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter an url label made up of lowercase letters (a-z), digits (0-9), underscore (_), and/or dashes (-).';
            this.expression = REGEXS.URLLABEL;
        }
    }

    /// <summary>
    /// Class for validating a single hostname.
    /// </summary>
    class HostNameTester extends ExpressionSet {
        constructor() {
            super();
            const self = this;
            this.validationErrorMessage = 'Enter an valid hostname made up of lowercase letters (a-z), digits (0-9), hyphens (-), and/or periods (.).';
            this.expression = {
                "test": function (value) {
                    return self.isValue(value) && REGEXS.HOSTNAME.test(value);
                }
            };
        }
    }

    /// <summary>
    /// Class for validating a logon name.
    /// </summary>
    class LogonNameTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a logon name. A logon name should have at least three characters. Those characters may be letters and/or digits.';
            this.expression = REGEXS.LOGONNAME;
        }
    }

    /// <summary>
    /// Class for validating a single email address.
    /// </summary>
    class EmailTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a valid email address (myemail@somewhere.org).';
            this.expression = {
                "test": function (aValue, aField) {
                    if (FBUtilities.IsStringEmptyOrWhitespace(aValue)) {
                        return false;
                    }

                    if (aValue.length > 254) {
                        return false;
                    }

                    let splits = aValue.split("@");
                    if (splits.length !== 2) {
                        return false;
                    }

                    if (splits[0].length > 64 || splits[0].length < 1) {
                        return false;
                    }

                    if (!REGEXS.EMAIL_USER.test(splits[0])) {
                        return false;
                    }

                    if (!REGEXS.EMAIL_DOMAIN.test(splits[1])) {
                        return false;
                    }

                    const allowedTlds = FBUtilities.GetAllowedTLDs();
                    const tld = splits[1].split('.').pop().toLowerCase();

                    if (allowedTlds.findIndex((entry) => entry === tld) === -1) {
                        return false;
                    }

                    return true;
                }
            }
        }
    }

    /// <summary>
    /// Class for validating simple, old style telephone numbers. 
    /// Examples:
    ///  1-313-555-1212
    ///  1 (313) 555-1212
    ///  555-1212
    /// </summary>
    class TelephoneTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a seven to eleven digit phone number. Examples: 555-555-2121, 555-2121';
            this.expression = REGEXS.TELEPHONE_US;
        }
    }

    /// <summary>
    /// Class for validating a phone number.
    /// </summary>
    class PhoneNumberTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a seven to thirteen digit phone number. Optional dashes, dots or plus character may be used. Examples: +011.555.555.2121, (555) 555-2121, 1-555-555-2121';
            this.expression = REGEXS.TELEPHONE_FULL;
        }
    }

    /// <summary>
    /// Class for validating a fax number.
    /// </summary>
    class FaxNumberTester extends PhoneNumberTester {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a fax phone number with seven to thirteen digits. Optionally, include dashes, dots or the plus up front. Examples: +011.555.555.2121, (555) 555-2121, 1-555-555-2121';
        }
    }

    /// <summary>
    /// Class for validating a basic american date. (01/02/2001)
    /// </summary>
    class DateTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a date in the format MM/DD/YYYY';
            this.expression = REGEXS.DATE_US
        }
    }

    /// <summary>
    /// Class for validating a standard ISO date. (YYYY-MM-DD)
    /// </summary>
    class IsoDateTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter an date in the ISO format YYYY-MM-DD. Example: 2018-12-23';
            this.expression = REGEXS.DATE_ISO;
        }
    }

    /// <summary>
    /// Class for validating a standard ISO date (YYYY-MM-DD) from a input of type DATE
    /// </summary>
    class DateInputTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Please choose a date.';
            this.expression = {
                "test": function (aValue, aField) {
                    const regEx = FBUtilities.IsHtmlDateField(aField) ? REGEXS.DATE_ISO : REGEXS.DATE_US_PADDED;
                    return regEx.test(aValue);
                }
            }
        }
    }

    /// <summary>
    /// Class for validating a time in the 12 hour format hh:mm.
    /// </summary>
    class TwelveHourTimeTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a time in 12 hour format hh:mm. Example: 12:00, 9:00, 09:00';
            this.expression = REGEXS.TIME_12H_NOMERIDIAN;
        }
    }

    /// <summary>
    /// Class for validating a time in an AM/PM time format.
    /// </summary>
    class AmPmTimeTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a time in the 12 hour format including the AM/PM designator. Examples: 11:30 AM, 11:30 pm';
            this.expression = REGEXS.TIME_12H_MERIDIAN;
        }
    }

    /// <summary>
    /// Class for validating a time value from a input of type TIME
    /// </summary>
    class TimeInputTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Please choose a time.';
            this.expression = {
                "test": function (aValue, aField) {
                    const regEx = FBUtilities.IsHtmlTimeField(aField) ? REGEXS.TIME_24H : REGEXS.TIME_12H_MERIDIAN;
                    return regEx.test(aValue);
                }
            }
        }
    }

    /// <summary>
    /// Class for validating a percentage value.
    /// </summary>
    class PercentageTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a percentage value from 0 through 100. Examples: 0, 50, 100';
            this.expression = REGEXS.PERCENTAGE;
        }
    }

    /// <summary>
    /// Class for validating the basic format of single line text.
    /// </summary>
    class TextTester extends ExpressionSet {
        constructor(maxLength) {
            super();
            if (maxLength === undefined) {
                this.expression = REGEXS.TEXT_UNLIMITED;
                this.validationErrorMessage = 'Please enter the required information.';
            }
            else {
                this.expression = new RegExp('^.{1,' + maxLength + '}$');
                this.validationErrorMessage = ' Text may not exceed ' + maxLength + ' characters.';
            }
        }
    }

    /// <summary>
    /// Class for validating the basic format of single line text.
    /// </summary>
    class PlainTextTester extends ExpressionSet {
        constructor(maxLength, disallowHtml) {
            super();

            let quantifier;
            if (maxLength === undefined) {
                quantifier = '+';
                this.validationErrorMessage = 'Please enter the required information.';
            }
            else {
                quantifier = '{1,' + maxLength + '}';
                this.validationErrorMessage = ' Text may not exceed ' + maxLength + ' characters.';
            }

            let noHtml;
            if (disallowHtml === undefined) {
                noHtml = false;
            }
            else if (disallowHtml === true) {
                noHtml = true;
                this.validationErrorMessage = this.validationErrorMessage + " HTML is not allowed.";
            }
            else {
                noHtml = false;
            }

            const textRegex = new RegExp('^[\\w\\s`~!@#$%^&*()\-_=+\\[{\\]}\\|;:\'",\./?]' + quantifier + '$');
            this.expression = {
                "test": function (someValue) {
                    let success = textRegex.test(someValue);
                    if (noHtml) {
                        success = false === REGEXS.HTML_TAG.test(someValue);
                    }
                    return success;
                }
            }
        }
    }

    /// <summary>
    /// Class for validating the format of an html id.
    /// </summary>
    class HtmlIdTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter an HTML Id. An html id must begin with a letter (a-z, A-Z), followed by any combination of letters (a-z, A-Z), digits (0-9), hyphens (-), or underscores (_). Two hundred character limit.';
            this.expression = REGEXS.HTMLID;
        }
    }

    /// <summary>
    /// Class for validating a single path segment.
    /// </summary>
    class PathNameTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a simple path segment name.  This name may included uppercase letters (A-Z), lowercase letters (a-z), digits (0-9), and/or underscores (_).';
            this.expression = REGEXS.PATHNAME;
        }
    }

    /// <summary>
    /// Class for validating a single path segment.
    /// </summary>
    class FileNameTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a file name.  This name may included uppercase letters (A-Z), lowercase letters (a-z), digits (0-9), underscores (_), and/or periods (.).';
            this.expression = REGEXS.FILENAME;
        }
    }

    /// <summary>
    /// Class for validating basic text format.
    /// </summary>
    class SimpleTextTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter some text. The text may contain letters (a-z, A-Z), digits (0-9), forward slashes (/), periods (.), commas(,), dashes (-), and/or whitespace';
            this.expression = REGEXS.SIMPLETEXT;
        }
    }

    /// <summary>
    /// Class for validating basic multiline text.
    /// </summary>
    class TextAreaTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Please enter the required information.';
            this.expression = REGEXS.TEXTAREA
        }
    }

    /// <summary>
    /// Class for validating a multiline text area with a maximum of 500 characters.
    /// </summary>
    class TextArea500Tester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter up to 500 characters of text.';
            this.expression = REGEXS.TEXTAREA_500;
        }
    }

    /// <summary>
    /// Class for validating a multiline text area with a maximum of 200 characters.
    /// </summary>
    class TextArea200Tester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter up to 200 characters of text.';
            this.expression = REGEXS.TEXTAREA_200;
        }
    }

    /// <summary>
    /// Class for validating spaceless text.
    /// </summary>
    class TextNoSpaceTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter some text without any spaces. No spaces.';
            this.expression = REGEXS.TEXT_NOSPACE;
        }
    }

    /// <summary>
    /// Class for validating a short path seqment.
    /// </summary>
    class ShortPathTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a path segment folder/subfolder name. This name my include letters, digits, underscores (_), and periods (.). This name may be up to 256 characters in length.';
            this.expression = REGEXS.SHORTPATH;
        }
    }

    /// <summary>
    /// Class for validating money.
    /// </summary>
    class MoneyTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a currency amount in the form dddd.dd. Examples: 1.99';
            this.expression = REGEXS.MONEY;
        }
    }

    /// <summary>
    /// Class for validating an integer value.
    /// </summary>
    class IntegerTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter a whole number. Examples: 1, 11, 111';
            this.expression = REGEXS.INTEGER;
        }
    }

    /// <summary>
    /// Class for validating a boolean value.
    /// </summary>
    class BooleanTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Enter "true" or "false"';
            this.expression = REGEXS.BOOLEAN;
        }
    }

    /// <summary>
    /// Class that validates a meaningful selection was made in a select list.
    /// </summary>
    class SelectTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Select an option';
            this.expression = REGEXS.SOMETHING;
        }
    }

    /// <summary>
    /// Class for validating a meaningful radio list selection.
    /// </summary>
    class RadioTester extends ExpressionSet {
        constructor() {
            super();
            this.validationErrorMessage = 'Select an option';
            this.expression = REGEXS.SOMETHING;
        }
    }

    /// <summary>
    /// Class for validating a postal code.
    /// </summary>
    class ZipCodeTester extends ExpressionSet {
        constructor() {
            super();
            const self = this;
            this.validationErrorMessage = 'Enter a zip or postal code. Examples: 12345, 12345-6789, A2C 4E6';
            this.expression = {
                "test": function (aValue) {
                    return REGEXS.ZIPCODE_US.test(aValue) || REGEXS.ZIPCODE_CA.test(aValue);
                }
            };
        }
    }

    /// <summary>
    /// Class for validating a value using a custom regex.
    /// </summary>
    class ExpressionTextChecker extends ExpressionSet {
        constructor(expressionText, validationErrorMessage) {
            super();
            this.validationErrorMessage = validationErrorMessage || 'Check your value.';
            if (expressionText === undefined) {
                this.expression = REGEXS.ANY;
            }
            else {
                const start = expressionText.charAt(0) === "/" ? 1 : 0;
                const end = expressionText.charAt(expressionText.length - 1) === "/" ? expressionText.length - 1 : expressionText.length;
                this.expression = new RegExp(expressionText.slice(start, end));
            }
        }
    }

    const defaultExpressionSetMap = Object.freeze({
        [TYPES.URL_LABEL]: new UrlLabelTester(),
        [TYPES.HOSTNAME]: new HostNameTester(),
        [TYPES.LOGONNAME]: new LogonNameTester(),
        [TYPES.PASSWORD]: new PasswordTester(),
        [TYPES.PASSWORD_LOOSE]: new PasswordTesterLoose(),
        [TYPES.EMAIL]: new EmailTester(),
        [TYPES.EMAIL_COLLECTION]: new EmailCollectionTester(),
        [TYPES.TEL]: new TelephoneTester(),
        [TYPES.PHONE]: new PhoneNumberTester(),
        [TYPES.FAX]: new FaxNumberTester(),
        [TYPES.DATE]: new DateTester(),
        [TYPES.DATE_ISO8601]: new IsoDateTester(),
        [TYPES.DATEINPUT]: new DateInputTester(),
        [TYPES.TIME]: new TwelveHourTimeTester(),
        [TYPES.TIME12H]: new TwelveHourTimeTester(),
        [TYPES.TIMEAMPM]: new AmPmTimeTester(),
        [TYPES.TIMEINPUT]: new TimeInputTester(),
        [TYPES.PERCENT]: new PercentageTester(),
        [TYPES.PLAINTEXT]: new PlainTextTester(),
        [TYPES.PLAINTEXT_NOHTML]: new PlainTextTester(undefined, true),
        [TYPES.TEXT]: new TextTester(),
        [TYPES.TEXT_20]: new TextTester(20),
        [TYPES.TEXT_30]: new TextTester(30),
        [TYPES.TEXT_50]: new TextTester(50),
        [TYPES.TEXT_100]: new TextTester(100),
        [TYPES.TEXT_200]: new TextTester(200),
        [TYPES.TEXT_240]: new TextTester(240),
        [TYPES.TEXT_2048]: new TextTester(2048),
        [TYPES.HTMLID]: new HtmlIdTester(),
        [TYPES.PATHNAME]: new PathNameTester(),
        [TYPES.FILENAME]: new FileNameTester(),
        [TYPES.SIMPLETEXT]: new SimpleTextTester(),
        [TYPES.TEXTAREA]: new TextAreaTester(),
        [TYPES.TEXTAREA_500]: new TextArea500Tester(),
        [TYPES.TEXTAREA_200]: new TextArea200Tester(),
        [TYPES.TEXT_NO_SPACE]: new TextNoSpaceTester(),
        [TYPES.WEBSITE]: new WebAddressTester(),
        [TYPES.WEBSITE_OR_ANCHOR]: new WebAddressOrAnchorTester(),
        [TYPES.URLPATH]: new UrlPathTester(),
        [TYPES.CANONICALPATH]: new CanonicalPathTester(),
        [TYPES.SHORTPATH]: new ShortPathTester(),
        [TYPES.MONEY]: new MoneyTester(),
        [TYPES.INTEGER]: new IntegerTester(),
        [TYPES.BOOLEAN]: new BooleanTester(),
        [TYPES.SELECT]: new SelectTester(),
        [TYPES.RADIO]: new RadioTester(),
        [TYPES.POSTALZIP]: new ZipCodeTester(),
        [TYPES.ZIPCODE]: new ZipCodeTester(),
        [TYPES.LINKTESTER]: new FBLinkTester()
    });

    /// <summary>
    /// formChecker is a jQuery Widget wrapper for the FormChecker class.
    /// </summary>
    $.widget("ui.vpformchecker",
        {
            options:
            {                
                /* USED EXTERNALLY  */
                /// If true the FormChecker will handle the cancel and submit buttons.
                useButtons: true,
                /// Return URL for the cancel button.
                cancelUrl: "/Admin/",
                /// jQuery selector for the form's cancel button.
                cancelButtonSelector: '.cancel_button',
                /// Indicates whether the cancel button element is contained by the form.
                cancelButtonInsideForm: true,
                /// Alternate callback function to call upon clicking the save button.
                saveButtonCallback: undefined,
                /// jQuery select for the form's save button.
                saveButtonSelector: '.save_button',
                /// Indicates whether the cancel button element is contained by the form.
                saveButtonInsideForm: true,
                /// Required market text append to label's belonging to required fields.
                requiredMarkerText: '*',
                /// Highlight tab containing errored fields
                highlightTabsWithErrors: true,
                // use new style form field styling. 
                manageFormFieldStyling: true,

                /* USED INTERNALLY */

                /// Class added to required form fields.
                requiredClass: "field_required",
                /// Class added to optional form fields.
                optionalClass: "field_optional",
                /// Class added to validated form fields.
                validatedClass: "field_validated",
                /// Class added to form fields with validation errors.
                warningClass: "field_warning",
                /// Class added to form fields that have passed validation.
                correctClass: "field_correct",
                /// Class applied to the required marker <span/> inserted after the label text.
                requiredSpanClass: "reqd_marker",
                /// Class applied to the dynamically validated marker <span/> inserted after the label text.
                validatedSpanClass: "validated_marker",
                /// Header text form the error displayed on top of the form when validation fails.
                formErrorMessage: "Please check the following fields: ",
                /// jQuery selector used to find form fields.
                inputSelector: ':input[data-validation-mode]',
                /// A class name applied to the <div/> containing form error messages.
                formValidationMessageClass: 'form-validation-message',
                previousAdminAlertClass: 'admin-alert',
                /// Alternate callback function to call upon clicking the cancel button.
                cancelButtonCallback: undefined,
                /// Show form error messages on top of form.
                showFormErrorsOnTop: true,
                /// Show form error messages at bottom or form.
                showFormErrorsAtBottom: true,
            },

            _destroy: function () {
                return undefined;
            },

            _init: function () {
                return undefined;
            },

            _create: function () {
                this._vars =
                {
                    /// Flag set if the value of any of form field changes.
                    valuesChanged: false,

                    /// Flag indicating that the form currently has no validation errors.
                    formHasNoErrors: true,

                    /// Set of FieldErrorEntry objects related to the current state of the form. The entries are keyed by id.
                    fieldErrors: {},

                    /// Set of other, extra validation functions that are called upon
                    /// sucessfully validating form fields. These functions indicate their respective validation statusese
                    /// by returning true or false.
                    otherFunctions: [],

                    // Set of panels which has their own internal checking. This form checker will
                    // call thier internal check functions while check other normal fields.
                    checkablePanels: {},

                    /// Create testing objects for the various validation types.
                    expressionSetMap: Object.assign({}, defaultExpressionSetMap)
                };

                if (this.options.manageFormFieldStyling) {
                    this.initFormSetupFields();

                    if (this.options.useButtons) {
                        this.setupButtons();
                    }
                }
            },

            checkForm: function () {
                const self = this;
                const jForm = $(this.element);
                if (!jForm || jForm.length === 0) {
                    return false;
                }
                
                self._vars.formHasNoErrors = true;
                self._vars.fieldErrors = {};

                this._htmlResetFormValidationMessage();

                getInputFields(this.element).each(function () {
                    if (hasValidationData(this)) {
                        const lStatus = self.checkField(this);
                        self._vars.formHasNoErrors = self._vars.formHasNoErrors && lStatus;
                    }
                });

                const keys = Object.keys(self._vars.checkablePanels);
                if (keys.length !== 0) {
                    keys.forEach(function (panelSelector) {
                        const panelInfo = self._vars.checkablePanels[panelSelector];
                        const status = panelInfo.checkFunction(panelSelector, self);
                        if (!status) {
                            self._setCheckablePanelErrorMessage(panelInfo);
                        }
                        self.updateTabsWithErrors();
                        self._vars.formHasNoErrors = self._vars.formHasNoErrors && status;
                    });
                }

                if (self._vars.formHasNoErrors) {
                    for (let lIdx = 0; lIdx < self._vars.otherFunctions.length; lIdx += 1) {
                        const lSuccess = self._vars.otherFunctions[lIdx](self.element, self);
                        if (!lSuccess) {
                            self._vars.formHasNoErrors = false;
                            break;
                        }
                    }
                }

                self.showFormErrorMessages(undefined, false);
                return self._vars.formHasNoErrors;
            },

            /// <summary>
            /// Validates the fields on the form.
            /// </summary>
            /// <param name="formSelector">jQuery selector of the form to check.</param>
            /// <returns>true if validation is successful, otherwise false.</returns>
            checkField: function (fieldSelector, previousRelatedSelectors) {
                const checkField_excludedInputTypes = ['HIDDEN', 'FILE', 'BUTTON', 'SUBMIT', 'RESET'];
                const checkField_includedNodeNames = ['SELECT', 'INPUT', 'TEXTAREA'];
                const self = this;
                const jField = $(fieldSelector);
                const fieldName = jField.attr('name');
                const inputType = jField.prop('type').toUpperCase();
                const mode = jField.data(KEYS.mode);
                const peekValidationType = jField.data(KEYS.type);
                let isBlank = false;
                let hasValidValue = false;
                let status = true;
                let relatedSelector = undefined;

                if (this.options.previousAdminAlertClass !== undefined) {
                    var removeSelector = '.' + this.options.previousAdminAlertClass;
                    setTimeout(function () {
                        $(removeSelector).remove();
                    }, 500);
                }

                if (jField.length === 0) {
                    return false;
                }

                // Reset messages.

                this._htmlResetFieldErrorMessage(jField);

                // Only checking select boxes, text inputs and text areas.
                const nodeName = jField.prop('nodeName').toUpperCase();
                if (!checkField_includedNodeNames.includes(nodeName)) {
                    return true;
                }

                // only care about data entry input fields.
                // ignore data entry fields.         
                if (nodeName === 'INPUT' && checkField_excludedInputTypes.includes(inputType)) {
                    return true;
                }


                let validationErrorMessage = "Please check your value.";

                if (nodeName === 'SELECT' && (peekValidationType === 'select' || peekValidationType === '')) {
                    // for select boxes just determine if the selected option has a non-empty value.
                    hasValidValue = (jField.val() !== '');
                    isBlank = !hasValidValue;
                    validationErrorMessage = "An option must be selected.";
                }
                else if (inputType === 'RADIO') {
                    // for radio buttons make sure at least one is checked.
                    hasValidValue = $('input:radio[name="' + fieldName + '"]:checked').length > 0;
                    isBlank = !hasValidValue;
                    validationErrorMessage = "Please select an option.";
                }
                else if (inputType === 'CHECKBOX') {
                    // for checkboxes make sure at least one box is checked.
                    hasValidValue = $('input:checkbox[name="' + fieldName + '"]:checked').length > 0;
                    isBlank = !hasValidValue;
                    validationErrorMessage = "Please check at least one option.";
                }
                else {
                    // for other fields use an ExpressionSet testing object to validate their values.                    
                    let expressionSet = new NeverPassTester();
                    if (jField.length !== 0) {
                        const validationType = jField.data(KEYS.type);
                        if (validationType !== undefined) {
                            if (typeof validationType === 'function') {
                                // using function bound to data validation type.
                                expressionSet = validationType;
                            }
                            else if (typeof validationType === 'string') {
                                if (this._vars.expressionSetMap[validationType] !== undefined) {
                                    // found a standard testing object.
                                    expressionSet = this._vars.expressionSetMap[validationType];
                                }
                                else {
                                    // assuming the data validation type value is some freeform regex text.
                                    validationErrorMessage = jField.data(KEYS.errormessage);
                                    expressionSet = new ExpressionTextChecker(validationType, validationErrorMessage);
                                }

                                // set an optional length value from the field's length attribute.
                                expressionSet.expectedLength = jField.attr('length');
                            }
                        }
                    }

                    if (expressionSet === undefined || expressionSet === null || expressionSet.expression === undefined || expressionSet.expression === null) {
                        return true;
                    }

                    if (expressionSet.relatedSelector !== undefined) {
                        relatedSelector = expressionSet.relatedSelector;
                    }

                    validationErrorMessage = expressionSet.validationErrorMessage;

                    const value = jField.val().replace(/^\s+/, '').replace(/\s+$/, '');
                    jField.val(value);
                    hasValidValue = expressionSet.expression.test(value, jField);
                    isBlank = (value === "");
                }

                // CHECK PASSWORD SILLINESS HERE ! //
                if (hasValidValue && (jField.data(KEYS.type) === TYPES.PASSWORD || jField.data(KEYS.type) === TYPES.PASSWORD_LOOSE)) {
                    const lPasswordLink = jField.data(KEYS.passwordLink);
                    if (lPasswordLink !== undefined && lPasswordLink !== null && lPasswordLink.length > 0) {
                        const jLinked = $(self._cleanSelector(lPasswordLink));
                        if (jField.val() !== jLinked.val()) {
                            validationErrorMessage = "Please enter the same password into both the password and confirmation fields.";
                            hasValidValue = false;
                            self._htmlSetFieldClass(jLinked, self.options.warningClass);

                            if (self.options.manageFormFieldStyling) {
                                self.applyWarningFieldStyling(jLinked);
                            }
                        }
                        else {
                            self._htmlSetFieldClass(jLinked, self.options.correctClass);
                            self._htmlResetFieldErrorMessage(jLinked);

                            if (self.options.manageFormFieldStyling) {
                                self.applySuccessFieldStyling(jLinked);
                            }
                        }
                    }
                }

                status = (mode === MODES.none || hasValidValue || (mode === MODES.optional && isBlank));

                if (status) {
                    self._htmlSetFieldClass(jField, self.options.correctClass);

                    if (self.options.manageFormFieldStyling) {
                        self.applySuccessFieldStyling(jField);
                    }
                }
                else {
                    self._htmlSetFieldErrorMessage(jField, validationErrorMessage);

                    if (self.options.manageFormFieldStyling) {
                        self.applyWarningFieldStyling(jField);
                    }
                }

                self.updateTabsWithErrors();
                self.showFormErrorMessages(undefined, true);

                if (relatedSelector !== undefined) {
                    if (previousRelatedSelectors === undefined) {
                        previousRelatedSelectors = [];
                    }

                    let selectors;
                    if (Array.isArray(relatedSelector)) {
                        selectors = relatedSelector;
                    }
                    else {
                        selectors = [relatedSelector];
                    }

                    selectors.forEach(function (selectorValue) {
                        if (!previousRelatedSelectors.includes(selectorValue)) {
                            previousRelatedSelectors.push(selectorValue);
                            let relatedStatus = self.checkField(selectorValue, previousRelatedSelectors);
                            status = (status && relatedStatus);
                        }
                    });
                }
                return status;
            },

            initFieldEventHandlers: function (fieldSelector) {
                const jField = $(fieldSelector);
                const self = this;

                jField.on('change', function () {
                    self._vars.formHasNoErrors = self._vars.formHasNoErrors && self.checkField(fieldSelector);
                    this.valuesChanged = true;
                });

                jField.on('blur', function () {
                    self.checkFieldAndUpdateStatus(fieldSelector);
                });

                const toAdd = [];
                const toRemove = [self.options.correctClass, self.options.warningClass];
                const validationMode = jField.data(KEYS.mode);

                if (validationMode === MODES.required) {
                    toRemove.push([self.options.optionalClass, self.options.validatedClass]);
                    toAdd.push(self.options.requiredClass);
                }
                else if (validationMode === MODES.optional) {
                    toRemove.push([self.options.requiredClass, self.options.validatedClass]);
                    toAdd.push(self.options.optionalClass);
                }
                else if (validationMode === MODES.validated) {
                    toRemove.push([self.options.optionalClass, self.options.requiredClass]);
                    toAdd.push(self.options.validatedClass);
                }
                else {
                    toRemove.push([self.options.optionalClass, self.options.requiredClass, self.options.validatedClass]);
                }

                jField.removeClass(toRemove);
                jField.addClass(toAdd);
            },

            checkFieldAndUpdateStatus: function (fieldSelector) {
                const status = this.checkField(fieldSelector);
                this._vars.formHasNoErrors = this._vars.formHasNoErrors && status;
                return status;
            },

            /// <summary>
            /// Adds an external validation function. This function will get called if regular form validation is
            /// successful.  The other function should return true or false to indicate the status of its own validation efforts.
            /// The function will receive the form and checker as parameters. 
            /// </summary>
            /// <param name="otherFunction">A function object.</param>
            addOtherFunction: function (otherFunction) {
                if (otherFunction !== undefined && otherFunction !== null && typeof otherFunction === 'function') {
                    this._vars.otherFunctions[this._vars.otherFunctions.length] = otherFunction;
                }
            },

            /// <summary>
            /// Checks and submits a form.
            /// </summary>
            submitForm: function (presubmitFunc, errorFunc) {
                if (this.checkForm()) {
                    this._vars.valuesChanged = false;

                    if (presubmitFunc !== undefined && typeof presubmitFunc === 'function') {
                        presubmitFunc();
                    }

                    $(this.element).submit();
                }
                else {
                    if (errorFunc !== undefined && typeof errorFunc === 'function') {
                        errorFunc();
                    }
                }
            },

            /// <summary>
            /// Changes the callback function called by the submit button.
            /// </summary>
            /// <param name="saveButtonCallback">The save callback function.</param>
            changeSaveButtonCallback: function (saveButtonCallback) {
                if (saveButtonCallback !== undefined && typeof saveButtonCallback === 'function') {
                    this.options.saveButtonCallback = saveButtonCallback;
                }
            },

            /// <summary>
            /// Changes the callback function called by the cancel button.
            /// </summary>
            /// <param name="cancelButtonCallback">The cancel callback function.</param>
            changeCancelButtonCallback: function (cancelButtonCallback) {
                if (cancelButtonCallback !== undefined && typeof cancelButtonCallback === 'function') {
                    this.options.cancelButtonCallback = cancelButtonCallback;
                }
            },

            /// <summary>
            /// Apply data attributes to a field so as to identify its validation requirements.
            /// </summary>
            /// <param name="fieldSelector">jQuery selector of the field.</param>
            /// <param name="validationType">Declares what type of data to check for.</param>
            /// <param name="isRequired">If true then a value is required.</param>
            /// <param name="fieldTitle">A short description of the field for error messages.</param>
            identifyField: function (fieldSelector, validationType, validationMode, fieldTitle, fieldMessage) {
                if (fieldSelector === undefined || fieldSelector === null) {
                    return;
                }

                const jField = jQuery(fieldSelector);
                if (jField.length === 0) {
                    return 0;
                }

                jField.data(KEYS.title, fieldTitle || jField.prop("name"));
                jField.data(KEYS.message, fieldMessage);
                jField.data(KEYS.mode, cleanValidationMode(validationMode));
                jField.data(KEYS.type, validationType);
            },


            _initField: function (aField, requiredMarkerText) {
                const reqMarkerText = (requiredMarkerText !== undefined) ? requiredMarkerText : this.options.requiredMarkerText;
                const field = $(aField);
                const validationMode = field.data(KEYS.mode);

                if (validationMode === MODES.none || !hasValidationData(aField)) {
                    return;
                }

                const fieldContainer = field.parents('.fbcms_custom_form_field');
                const id = field.attr('id');
                let jLabel = $(this.element).find(`label[for='${id}']`);
                if (jLabel.length === 0) {
                    const name = field.attr('name');
                    jLabel = $(this.element).find(`label[for='${name}']`);
                }

                if (field.is("[type='radio']") || field.is("[type='checkbox']")) {
                    if (fieldContainer.length === 1) {
                        jLabel = fieldContainer.children('.fbcms_custom_form_field_label').children('label,span');
                    }
                }

                let labelText;
                if (jLabel.length > 0) {
                    labelText = jLabel.text();
                }
                else {
                    labelText = field.data(KEYS.title) || field.prop("name");
                }

                this.identifyField(aField, field.data(KEYS.type), validationMode, labelText);

                if (validationMode === MODES.required) {
                    jLabel.children(`.${this.options.validatedSpanClass}`).remove();

                    if (jLabel.has(`span.${this.options.requiredSpanClass}`).length === 0) {
                        jLabel.append(`<span class="${this.options.requiredSpanClass} required">${reqMarkerText}</span>`);
                    }

                    if (fieldContainer.length === 1) {
                        fieldContainer.addClass('fbcms_required');
                    }
                }
                else if (validationMode === MODES.validated) {
                    jLabel.children(`.${this.options.requiredSpanClass}`).remove();
                    if (jLabel.has(`span.${this.options.validatedSpanClass}`).length === 0) {
                        jLabel.append(`<span class="${this.options.validatedSpanClass} required">${reqMarkerText}</span>`);
                    }

                    if (fieldContainer.length === 1) {
                        fieldContainer.addClass('fbcms_required');
                    }
                }
                else {
                    jLabel.removeClass('required');
                    jLabel.children(`.${this.options.requiredSpanClass}`).remove();
                    jLabel.children(`.${this.options.validatedSpanClass}`).remove();

                    if (fieldContainer.length === 1) {
                        fieldContainer.removeClass('fbcms_required');
                    }
                }

                const passwordLink = field.data(KEYS.passwordLink);
                const hasPasswordLink = (passwordLink !== undefined && passwordLink !== null && passwordLink.length > 0);
                if (hasPasswordLink) {
                    const password = `#${id}`;
                    const confirm = passwordLink;
                    if (password !== undefined && password !== null && confirm !== undefined && confirm !== null) {
                        const self = this;
                        const passwordSelector = self._cleanSelector(password);
                        const confirmSelector = self._cleanSelector(confirm);
                        const jqPassword = $(passwordSelector);
                        const jqConfirm = $(confirmSelector);

                        if (jqPassword.length === 0 || jqConfirm.length === 0) {
                            return;
                        }

                        jqPassword.data(KEYS.passwordLink, jqConfirm.attr('id'));
                        jqConfirm.data(KEYS.passwordLink, jqPassword.attr('id'));
                    }
                }
            },

            /// <summary>
            /// Initializes a form and its fields based upon data attributes in the form field markup.
            /// </summary>
            initFormSetupFields: function (requiredMarkerText) {

                const self = this;
                getInputFields(this.element).each(function () {
                    self._initField(this, requiredMarkerText);
                    if (hasValidationData(this)) {
                        self.initFieldEventHandlers(this);
                    }
                });

                self.options.formErrorMessage = 'Required Information is missing or incorrect. Please check the highlighted fields.';
            },

            /// <summary>
            /// Resets all form fields.
            /// </summary>
            resetFormSetupFields: function () {
                this._htmlResetFormSetupFields();
            },
            

            /// <summary>
            /// Prepares and displays error messages.
            /// </summary>
            /// <param name="message">Summary error message.</param>
            showFormErrorMessages: function (customErrorMessage, updateOnly) {
                const showUpdateOnly = (updateOnly !== undefined) ? updateOnly : false;
                if (showUpdateOnly && (!this.options.manageFormFieldStyling || !this._htmlIsFormValidationMessage())) {
                    return;
                }

                this._htmlResetFormValidationMessage();

                let errorMessage;
                if (FBUtilities.IsStringEmptyOrWhitespace(customErrorMessage)) {
                    const keys = Object.keys(this._vars.fieldErrors);
                    if (keys.length === 0) {
                        return;
                    }
                    errorMessage = this.options.formErrorMessage;
                }
                else {
                    errorMessage = customErrorMessage;
                }

                if (!this.options.manageFormFieldStyling) {
                    this._htmlDisplayLegacyAlert(errorMessage, showUpdateOnly);
                }
                else {
                    this._htmlShowFormValidationMessage(errorMessage, showUpdateOnly);
                }
            },

            addCheckablePanel: function (panelSelector, label, validationErrorMessage, checkFunction) {
                if (FBUtilities.IsStringEmptyOrWhitespace(panelSelector) || (typeof checkFunction !== "function") || (typeof panelSelector !== "string")) {
                    return;
                }

                this._vars.checkablePanels[panelSelector] = {
                    id: panelSelector,
                    checkFunction: checkFunction,
                    label: label,
                    validationErrorMessage: validationErrorMessage
                };
            },

            _setCheckablePanelErrorMessage: function (panelInfo) {
                this._vars.fieldErrors[panelInfo.id] = {
                    id: panelInfo.id,
                    label: panelInfo.label,
                    validationErrorMessage: panelInfo.validationErrorMessage
                };
            },

            reportCheckablePanelStatus: function (panelSelector, status) {
                if (panelSelector in this._vars.checkablePanels) {
                    const panelInfo = this._vars.checkablePanels[panelSelector];
                    if (panelInfo !== undefined) {
                        if (!status) {
                            this._setCheckablePanelErrorMessage(panelInfo);
                        }
                        else if (panelInfo.id in this._vars.fieldErrors) {
                            this._vars.fieldErrors
                            delete this._vars.fieldErrors[panelInfo.id];
                        }

                        if (this.options.highlightTabsWithErrors) {
                            this._htmlUpdateTabsWithErrors();
                        }
                    }
                }
            },

            updateTabsWithErrors: function () {
                if (this.options.highlightTabsWithErrors) {
                    this._htmlUpdateTabsWithErrors();
                }
            },

            /// <summary>
            /// Associates a new or existing validation type name with a testing object. The object should 
            /// be derived from the ExpressionSet() class or least implement the same methods and properties.
            /// </summary>
            /// <param name="validationType">Validation type name. (Values are enumerated in the TYPES object.)</param>
            /// <param name="expressionSet">Testing object.</param>
            addCustomExpressionSet: function (validationType, expressionSet) {
                if (validationType !== undefined && expressionSet !== undefined) {
                    this._vars.expressionSetMap[validationType] = expressionSet;
                }
            },

            /// <summary>
            /// Applies warning styling to a field.
            /// </summary>
            /// <param name="fieldSelector">jQuery selector of the field.</param>
            applyWarningFieldStyling: function (fieldSelector) {
                this._htmlApplyFieldStyling(fieldSelector, "has-error", "is-invalid");
            },

            /// <summary>
            /// Applies success styling to a field.
            /// </summary>
            /// <param name="fieldSelector">jQuery selector of the field.</param>
            applySuccessFieldStyling: function (fieldSelector) {
                this._htmlApplyFieldStyling(fieldSelector, "has-success", "is-valid");
            },

            /// <summary>
            /// Determines if there are any form changes and if the user still wishes to procede with an action that may discard those changes.
            /// </summary>
            /// <param name="continueCallback">Callback function called if it is ok to continue.</param>
            /// <param name="cancelCallback">Callback function called if it is not ok to continue.</param>
            /// <param name="warningMessage">Specifies an alternate alert message.</param>
            /// <returns>true if it is fine to proceed.</returns>
            checkAndWarnIfValuesChanged: function (continueCallback, cancelCallback, warningMessage) {

                let canContinue = true;
                if (this._vars.valuesChanged) {
                    let message;
                    if (warningMessage !== undefined && warningMessage !== null && warningMessage !== '') {
                        message = warningMessage;
                    }
                    else {
                        message = 'Any Changes will be lost, select OK to Continue.';
                    }
                    canContinue = window.confirm(message);
                }

                if (canContinue) {
                    if (continueCallback !== undefined && typeof continueCallback === "function") {
                        continueCallback();
                    }
                }
                else {
                    if (cancelCallback !== undefined && typeof cancelCallback === "function") {
                        cancelCallback();
                    }
                }

                return canContinue;
            },

            /// <summary>
            /// Sets or Resets the form errors flag.
            /// </summary>
            /// <param name="hasNoError">true if no errors, otherwise false.</param>
            setFormHasNoErrors: function (hasNoError) {
                this._vars.formHasNoErrors = hasNoError;
            },

            setupButtons: function (customOptions) {
                if (customOptions !== undefined) {

                    if (customOptions.cancelUrl !== undefined) {
                        this.options.cancelUrl = customOptions.cancelUrl;
                    }

                    if (customOptions.saveButtonCallback !== undefined) {
                        this.options.saveButtonCallback = customOptions.saveButtonCallback;
                    }

                    if (customOptions.cancelButtonCallback !== undefined) {
                        this.options.cancelButtonCallback = customOptions.cancelButtonCallback;
                    }

                    if (customOptions.saveButtonSelector !== undefined) {
                        this.options.saveButtonSelector = customOptions.saveButtonSelector;
                    }
                }

                this._htmlConfigureCancelButton();
                this._htmlConfigureSaveButton();
            },

            updateFieldIsRequired: function (fieldSelector, validationMode) {
                const jField = $(fieldSelector);
                if (jField.length !== 0) {
                    const scrubbedValidationMode = cleanValidationMode(validationMode);
                    if (jField.data(KEYS.mode) !== scrubbedValidationMode) {
                        jField.data(KEYS.mode, scrubbedValidationMode);
                        this._initField(jField);
                        this.checkFieldAndUpdateStatus(fieldSelector);
                    }
                }
            },

            _cleanSelector: function (rawSelector) {
                let selector = rawSelector;
                if (selector !== undefined && typeof selector === 'string' && (/^[a-zA-Z]/).test(selector)) {
                    selector = "#" + selector;
                }
                return selector;
            },

            resetFieldErrorMessage: function (field) {
                this._htmlResetFieldErrorMessage(field);
            },
            setFieldErrorMessage: function (field, validationErrorMessage) {
                this._htmlSetFieldErrorMessage(field, validationErrorMessage);
            },
            setFieldClass: function (fieldSelector, className) {
                this._htmlSetFieldClass(fieldSelector, className);
            },
            setupFieldAjaxChecking: function(aFieldSelector, aFieldParameterName, aCheckValueUrl, aInitData, aErrorCheckingMessage, aPreCheckFunc) {
                const self = this;
                const preCheckFunc = aPreCheckFunc;
                const errorCheckingMessage = aErrorCheckingMessage;
                const initData = aInitData;
                const checkValueUrl = aCheckValueUrl;
                const fieldParameterName = aFieldParameterName;
                const fieldSelector = aFieldSelector;

                $(fieldSelector).on("blur", function(aEvent) {
                    const jElement = $(this);

                    if (preCheckFunc !== undefined && (typeof preCheckFunc === "function")) {
                        preCheckFunc();
                    }

                    self._htmlResetFieldErrorMessage(jElement);
                    const data = Object.assign({}, initData);
                    data[fieldParameterName] = jElement.val();
                    $.ajax(checkValueUrl, {
                        data: data,
                        complete: function (aJqXHR, aTextStatus) {
                            jElement.removeClass('field_warning');
                            if (aJqXHR === null) {
                                self._htmlSetFieldErrorMessage(jElement, errorCheckingMessage);
                            }
                            else {
                                if (aJqXHR.responseJSON.success === true) {
                                    if (aJqXHR.responseJSON.allowed === true) {
                                        // nothing.
                                        self._htmlSetFieldClass(jElement, 'field_correct');
                                        self.applySuccessFieldStyling(jElement);
                                    }
                                    else {
                                        self._htmlSetFieldErrorMessage(jElement, aJqXHR.responseJSON.messages);
                                    }
                                }
                            }
                            self.showFormErrorMessages(undefined, true);
                        },
                        type: 'GET'
                    });
                });
            },

            /* ===== HTML MANAGEMENT METHODS ===== */
            _htmlResetFormSetupFields: function () {
                const self = this;
                getInputFields()
                    .filter(function () {return hasValidationData(this);})
                    .each(function () {
                        const jField = $(this);
                        jField.removeData([KEYS.title, KEYS.message, KEYS.passwordLink, KEYS.mode, KEYS.type]);
                        jField.removeClass([self.options.correctClass, self.options.warningClass, self.options.requiredClass, self.options.optionalClass]);
                        jField.unbind("change").unbind("blur");

                        const jLabel = $("label[for='" + jField.attr('name') + "']");
                        jLabel.removeClass('required');
                        jLabel.parents(".has-error").removeClass("has-error");
                        jLabel.find('span.' + self.options.requiredSpanClass).remove();
                        jLabel.find('span.' + self.options.validatedSpanClass).remove();
                    });
            },
            _htmlResetFieldErrorMessage: function (field) {
                const jField = $(field);
                delete this._vars.fieldErrors[jField.attr('id')];

                this._htmlClearFieldStyling(field);
                const jParent = this._htmlFindEnclosingParent(jField);
                if (jParent !== undefined) {
                    let jErrorBlock = jParent.next(".error-block");
                    if (jErrorBlock.length === 0) {
                        jErrorBlock = jField.next(".error-block");
                    }
                    jErrorBlock.remove();
                }
            },
            _htmlSetFieldErrorMessage: function (field, validationErrorMessage) {
                const jField = $(field);
                const fieldErrorEntry = {
                    id: jField.attr('id'),
                    label: jField.data(KEYS.title) || jField.prop("name"),
                    validationErrorMessage: jField.data(KEYS.message) || validationErrorMessage
                };

                this._htmlSetFieldClass(field, this.options.warningClass);
                if (this.options.manageFormFieldStyling) {
                    this.applyWarningFieldStyling(field);
                }

                this._vars.fieldErrors[fieldErrorEntry.id] = fieldErrorEntry;

                const jParent = this._htmlFindEnclosingParent(jField);
                if (jParent === undefined) {
                    return;
                }

                let jErrorBlock;
                if (jParent.hasClass('col-md-9')
                    || jParent.hasClass('col-md-6')) // HACKITY HACKHACK
                {
                    jErrorBlock = jParent.find(".error-block");

                    if (jErrorBlock.length === 0) {
                        jParent.append('<span class="error-block help-block"> ??? </span>');
                        jErrorBlock = jParent.find(".error-block");
                    }
                    else {
                        jErrorBlock.css('visibility', 'visible')
                    }
                }
                else {
                    jErrorBlock = jParent.next(".error-block");

                    if (jErrorBlock.length === 0) {
                        jParent.after('<span class="error-block help-block"> ??? </span>');
                        jErrorBlock = jParent.next(".error-block");
                    }
                    else {
                        jErrorBlock.css('visibility', 'visible')
                    }
                }

                jErrorBlock.html(`<p>${fieldErrorEntry.validationErrorMessage}</p>\n`);
            },
            _htmlSetFieldClass: function (fieldSelector, className) {
                let jField = $(fieldSelector);
                if (jField.is('[type="radio"]') || jField.is('[type="checkbox"]')) {
                    // use wrapper for radio and checkboxes.
                    jField = jField.parents('.fbcms_custom_form_field_input');
                }

                const toRemove = [this.options.correctClass, this.options.requiredClass, this.options.warningClass].filter((name) => name !== className);
                jField.addClass(className).removeClass(toRemove);
            },
            _htmlFindEnclosingParent: function (field) {
                const jField = $(field);
                const nodeName = jField.prop('nodeName').toUpperCase();
                let jParent = undefined;
                if (nodeName === 'INPUT') {
                    const inputType = jField.attr("type").toUpperCase();
                    if (inputType === 'RADIO' || inputType === 'CHECKBOX') {
                        jParent = jField.closest('div');
                    }
                    else {
                        jParent = jField.parent();
                    }
                }
                else if (nodeName === 'SELECT') {
                    jParent = jField;
                }
                else if (nodeName === 'TEXTAREA') {
                    jParent = jField.parent();
                }
                return jParent;
            },
            _htmlConfigureCancelButton: function () {
                const self = this;
                const jCancelButton = this.options.cancelButtonInsideForm ? $(this.element).find(this.options.cancelButtonSelector) : $(this.options.cancelButtonSelector);
                jCancelButton.off('mousedown').on("mousedown", function (aEvent) {
                    const buttonClicked = this;

                    aEvent.preventDefault();
                    if (self.options.cancelButtonCallback !== undefined && typeof (self.options.cancelButtonCallback) === 'function') {
                        self.options.cancelButtonCallback(self.options.cancelUrl);
                    }
                    else {
                        self.checkAndWarnIfValuesChanged(function () {
                            let buttonaction = $(buttonClicked).data('buttonaction');
                            if (FBUtilities.IsStringEmptyOrWhitespace(buttonaction)) {
                                buttonaction = "cancel";
                            }
                            $(self.element).find('[name="buttonaction"]').val(buttonaction);
                            document.location = self.options.cancelUrl;
                        });
                    }
                    return false;
                });
            },
            _htmlConfigureSaveButton: function () {
                const self = this;
                const jSaveButton = this.options.saveButtonInsideForm ? $(this.element).find(this.options.saveButtonSelector) : $(this.options.saveButtonSelector);
                jSaveButton.off('click').on("click", function (aEvent) {
                    const buttonClicked = this;
                    aEvent.preventDefault();
                    aEvent.stopPropagation();
                    if (self.options.saveButtonCallback !== undefined && typeof (self.options.saveButtonCallback) === 'function') {
                        self.options.saveButtonCallback(self.element, self);
                    }
                    else {
                        if (false === self.checkForm()) {
                            return false;
                        }

                        let buttonaction = $(buttonClicked).data('buttonaction');
                        if (FBUtilities.IsStringEmptyOrWhitespace(buttonaction)) {
                            buttonaction = "save";
                        }
                        $(self.element).find('[name="buttonaction"]').val(buttonaction);
                        $(self.element).submit();
                    }
                    return false;
                });
            },
            _htmlClearFieldStyling: function (field) {
                const jField = $(field);
                if (this.options.manageFormFieldStyling) {
                    jField.removeClass('is-valid');
                    jField.removeClass('is-invalid');
                    if (jField.is(':checkbox') && jField.parent().is('label.mt-checkbox')) {
                        jField.parent().removeClass('is-valid');
                        jField.parent().removeClass('is-invalid');
                    }

                    const jFormGroup = jField.closest('.form-group');
                    jFormGroup.removeClass('has-warning');
                    jFormGroup.removeClass('has-error');
                    jFormGroup.removeClass('has-success');
                    jFormGroup.removeClass('is-htmleditor');
                }
            },
            _htmlApplyFieldStyling: function (fieldSelector, groupClass, fieldClass) {
                const jField = $(fieldSelector);
                const jFormGroup = jField.closest('.form-group');
                const fieldId = jField.attr('id');
                const isHtmlEditor = jField.next(`div#cke_${fieldId},span#cke_${fieldId}`).length !== 0;

                this._htmlClearFieldStyling(fieldSelector);

                jField.addClass(fieldClass);
                if (jField.is(':checkbox') && jField.parent().is('label.mt-checkbox')) {
                    $(fieldSelector).parent().addClass(fieldClass);
                }

                if (isHtmlEditor) {
                    jFormGroup.addClass('is-htmleditor');
                }

                jFormGroup.addClass(groupClass);
            },
            _htmlUpdateTabsWithErrors: function () {
                $(this.element).find(".fbadm_tabs .nav-tabs li").removeClass("fbErrorInTab");
                const keys = Object.keys(this._vars.fieldErrors);
                if (keys.length !== 0) {
                    const self = this;
                    keys.forEach(function (key) {
                        let selector = self._vars.fieldErrors[key].id;
                        if (selector[0] !== "#") {
                            selector = `#${selector}`;
                        }

                        const labelledById = $(selector).closest(".tab-pane").attr("aria-labelledby");
                        $("#" + labelledById).parent().addClass("fbErrorInTab");
                    });
                }
            },
            _htmlDisplayLegacyAlert: function (errorMessage, showUpdateOnly) {
                // Display using legacy style and message box.
                var alertMessage = "";
                alertMessage += errorMessage;
                alertMessage += "\n\n";
                const self = this;
                Object.keys(this._vars.fieldErrors).forEach(function (key) {
                    var fieldErrorEntry = self._vars.fieldErrors[key];
                    alertMessage += fieldErrorEntry.label;
                    alertMessage += "\t";
                    alertMessage += fieldErrorEntry.validationErrorMessage;
                    alertMessage += "\n";
                });

                alert(alertMessage);
            },
            _htmlIsFormValidationMessage: function () {
                return $(this.element).find("." + this.options.formValidationMessageClass).length !== 0;
            },
            _htmlShowFormValidationMessage: function (errorMessage, showUpdateOnly) {

                // display error using newer style metronic tags.
                let markup = $('<div></div>');
                if (this.options.formValidationMessageClass !== undefined) {
                    markup.addClass(this.options.formValidationMessageClass);
                }
                markup.addClass('alert');
                markup.addClass('alert-danger');

                if (errorMessage !== undefined && errorMessage !== null) {
                    markup.append($('<div></div>').html(errorMessage));
                }

                const keys = Object.keys(this._vars.fieldErrors);
                if (keys.length !== 0) {
                    const self = this;
                    const sorted = [];
                    keys.forEach(function (key) {
                        sorted.push(self._vars.fieldErrors[key]);
                    });

                    sorted.sort(function (left, right) {
                        let result;
                        if (left.label < right.label) {
                            result = - 1;
                        }
                        else if (left.label > right.label) {
                            result = 1;
                        }
                        else {
                            result = 0;
                        }
                        return result;
                    });
                }

                if (this.options.showFormErrorsOnTop) {
                    $(this.element).prepend(markup.clone());
                }

                if (!showUpdateOnly && this.options.showFormErrorsAtBottom) {

                    const formActionsDiv = $(this.element).find('.form-actions');
                    if (formActionsDiv.length !== 0) {
                        formActionsDiv.prepend(markup.clone());
                        const self = this;
                        setTimeout(function () {
                            const buttonLocation = $(self.element).find('.form-actions button').position().top;
                            window.scrollTo(window.scrollX, window.scrollY + buttonLocation);
                        }, 1);
                    }
                }
            },
            _htmlResetFormValidationMessage: function() {
                $(this.element).find('.' + this.options.formValidationMessageClass).remove();
            }
        });
}(jQuery));
